// extracted by mini-css-extract-plugin
export default {"input":"IhXT4n","size-30":"vSm83l","size-34":"Ox1BBF"};